"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuideEditTabs = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var Icon_1 = require("../Icon");
var GuideEditTabs = function (_a) {
    var tabs = _a.tabs, _b = _a.LinkComponent, LinkComponent = _b === void 0 ? react_1.Link : _b, tabsProps = __rest(_a, ["tabs", "LinkComponent"]);
    var activeTab = tabs.findIndex(function (tab) { return tab.active; });
    var defaultIconColor = 'red.500';
    var tabsPadding = '6px 12px';
    return (React.createElement(react_1.Tabs, __assign({ variant: "guide", index: activeTab }, tabsProps),
        React.createElement(react_1.TabList, { width: "100%", flexWrap: "wrap", pl: 5 }, tabs.map(function (tab) {
            var _a;
            var cleanTabName = tab.name.toLowerCase().replace(/\s+/g, '');
            return (React.createElement(LinkComponent, { key: "".concat(cleanTabName, "Tab"), href: tab.url, "aria-label": "".concat(tab.name, " Tab") },
                React.createElement(react_1.Tab, { className: tab.active ? 'active' : '', padding: tabsPadding },
                    React.createElement(react_1.Text, { id: "".concat(cleanTabName, "Tab"), "data-tab": cleanTabName }, tab.name),
                    tab.icon && (React.createElement(Icon_1.Icon, { type: getTabIcon(tab.icon), mt: "-8px", ml: "2px", color: (_a = tab.iconColor) !== null && _a !== void 0 ? _a : defaultIconColor })))));
        }))));
};
exports.GuideEditTabs = GuideEditTabs;
var tabIcons = {
    'exclamation-circle': pro_solid_svg_icons_1.faExclamationCircle,
};
var getTabIcon = function (icon, defaultIcon) {
    if (defaultIcon === void 0) { defaultIcon = pro_solid_svg_icons_1.faExclamationCircle; }
    return icon in tabIcons ? tabIcons[icon] : defaultIcon;
};
